import type { TemplateFn } from "./index";
import { baseTimeline, pathTargets } from "./_helpers";

// Per-glyph stagger from below. Industry-standard timing: ~70ms between
// glyphs, each glyph 350ms total, overshoot to -3% then settle. Looks like
// a kinetic-type intro from a tech-conference reel.
export const kineticTypography: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  const targets = pathTargets(logo);
  const n = Math.max(1, targets.length);
  // Aim for ~60-90ms wall-clock stagger between glyphs.
  const staggerMs = Math.max(50, Math.min(110, base.durationMs / (n + 4)));
  const staggerN = staggerMs / base.durationMs;
  const glyphSpan = Math.min(0.5, 0.35 + staggerN * 0.5);

  return {
    ...base,
    tracks: targets.map((sel, i) => {
      const start = i * staggerN;
      const peak  = Math.min(start + glyphSpan * 0.85, 0.92);
      const settle = Math.min(start + glyphSpan, 0.97);
      return {
        target: sel,
        easing: "easeOutBack" as const,
        delay: 0,
        keyframes: [
          { t: 0,        opacity: 0, y: 56, scale: 0.7, rotate: 4 },
          { t: start,    opacity: 0, y: 56, scale: 0.7, rotate: 4 },
          { t: peak,     opacity: 1, y: -4, scale: 1.04, rotate: -1 },
          { t: settle,   opacity: 1, y:  0, scale: 1,    rotate: 0 },
          { t: 1,        opacity: 1, y:  0, scale: 1,    rotate: 0 },
        ],
      };
    }),
  };
};
